import { createReport } from '@bilibili/edu-report'
import { isNode } from '../utils/node-env'
import { searchStringToParams } from '../js/convert'
import { getABTest } from './utils'

// 保证abtest尽量提前获取
if (!isNode) {
  getABTest()
}
const logMap = [
  // 二级选课
  {
    path: ['/cheese/category'],
    page: 'category',
  },
  // 已购课程
  {
    path: ['/cheese/mine'],
    page: 'mine',
  },
  // 我的券包
  {
    path: ['/cheese/coupon'],
    page: 'coupon',
  },
  // 课程兑换
  {
    path: ['/cheese/exchange'],
    page: 'exchange',
  },
  // 付费详情页
  {
    path: ['/cheese/play/ep'],
    page: 'play',
  },
  {
    path: ['/cheese/invite/season/'],
    page: 'inviteSeason',
  },
  {
    path: ['/cheese/play/ss'],
    page: 'play',
  },
  // 升级页
  {
    path: ['/cheese/upgrade'],
    page: 'upgrade',
  },
  // 拼单记录
  {
    path: ['/cheese/dutch/history'],
    page: 'dutchHistory',
  },
  {
    path: ['/cheese/middle'],
    page: 'middle',
  },
  // 导师入驻
  {
    path: ['/cheese/cooperate'],
    page: 'cooperate',
  },
  {
    path: ['/cheese/dutch/share/'],
    page: 'dutchShare',
  },
  {
    path: ['/cheese/addWxgroup'],
    page: 'addWxgroup',
  },
  {
    path: ['/cheese/pages/shareCoupon'],
    page: 'shareCoupon',
  },
  // 首页
  {
    path: ['/cheese'],
    page: 'home',
  },
]

function getPagename() {
  let page = location && location.pathname
  if (page) {
    logMap.some(item => {
      if (Array.isArray(item.path)) {
        const isTarget = item.path.some(path => page.indexOf(path) > -1)
        if (isTarget) {
          page = item.page
          return true
        }
        return false
      }
    })
  }
  return page
}

const {csource = '', spm_id_from = ''} = (isNode ? {} : searchStringToParams(location.search))

const {
  ReportDirective,
  report,
  reportShow,
  reportPv: reportPvLog,
} = createReport({
  page: getPagename,
  common: {
    csource,
    spm_id_from,
  }
})

const reportPv = (info = {}) => {
  getABTest()
    .finally(() => {
      reportPvLog(getPagename(), info)
    })
}

// 为了兼容旧版本
function reportPvWithCsource(info = {}) {
  reportPv(info)
}

export {
  ReportDirective,
  report,
  reportShow,
  reportPv,
  reportPvWithCsource,
}
